import 'jquery';
import 'bootstrap/dist/js/bootstrap';

import Blazy from 'blazy';

import justifiedGallery from '../lib/justified_gallery/jquery.justifiedGallery.min.js';
import lightGallery from '../lib/lightgallery/js/lightgallery.js';
import lightSlider from '../lib/light-slider/lightslider.min.js';
import iCheck from '../lib/icheck/icheck.js';
import ionRangeSlider from '../lib/ionRangeSlider/ion.rangeSlider.js';

var Flickity = require('flickity');
require('flickity-imagesloaded');

require('./search.js');
require('./filters.js');
require('./ajax.js');

;(function() {
    var bLazy = new Blazy();
})();

$(document).ready(function() {
    $(".lightgallery").lightGallery({
        selector: '.gallery-item-n',
        pager: true,
        download: false
    });
});


var animate = false;


$(document).ready(function() {

    $('#contactsModal').on('shown.bs.modal', function () {

        var map = $('iframe.b-lazy')
        if (map) {
            var map_src = map.attr('data-src')
            map.attr({
                src: map_src
            })
        }

        $('#lazy_steps li img').each(function( index ){
            $(this).attr('src', $(this).attr('data-src'));
        });
    })

    //$('.filter-content').hide();


    if ($('.horny-widget').length){
        $('.horny-widget').parent('div').hide();
    }

    var hash = document.location.hash.replace('#!', '');
    if (hash) {
        console.log(hash);
        $(".nav-tabs a[href=\\"+hash+"]").tab('show');
    } 

    // Change hash for page-reload
    $('.nav-tabs a').on('shown.bs.tab', function (e) {
        window.location.hash = e.target.hash;
    });

    $('.prod-list-view button').click(function(){

        $('.products-output').removeClass('tile');
        $('.products-output').removeClass('list');
        $('.prod-list-view button').removeClass('active');
        $(this).addClass('active');
        $('.products-output').addClass($(this).attr('rel'));

        var class_name = $(this).attr('rel');

        var url = '/shop/api/set-list-template/';

        $.ajax({
            url: url,
            type: "GET",
            data: 'type='+class_name,
            success: function(response) {

            },
            error: function(response) {
                console.log(response);
            }
        });

    });

    $("#catalog").click(function() {
        $(this).addClass('active_catalog');
    });

    $("#catalog").blur(function() {
        $(this).removeClass('active_catalog');
    });

    //$('.filter-content').hide();
    $('.filter-title span').click(function() {
        $(this).toggleClass('open');
        $(this).parent().parent().find('.filter-content').toggle(300);
    });

    if ($(window).width() > 1199) {
        $('.filter .dropdown-menu').removeClass();
    }

    $('.answer').hide();
    $('.question span').click(function() {
        $(this).toggleClass('open');
        $(this).parent().parent().find('.answer').toggle(300);
    });

    $('.search input').focus(function(){
        $('.search').addClass('expand');
    });

});



if ($('#product_images').length) {
    new Flickity( '#product_images', {
        imagesLoaded: true,
        percentPosition: true
    });
}


$(document).ready(function(){
    $(window).scroll(function () {if ($(this).scrollTop() > 0) {$('#scroller').fadeIn();} else {$('#scroller').fadeOut();}});
    $('#scroller').click(function () {$('body,html').animate({scrollTop: 0}, 400); return false;});

    $('.catalog-submenu').hide();

    $('.sidebar-catalog-menu li').hover(
        function(){
            $(this).find('.catalog-submenu').show();
        },
        function(){
            $(this).find('.catalog-submenu').hide();
        }
        );

    $('.breadcrumb .drop > a').click(
        function(){
            $(this).parent().find('.catalog-submenu').toggle();
            return false;
        }
        );

    $('.photos-detail').justifiedGallery({
        margins : 5,
        rowHeight : 300,
        lastRow : 'justify'
    }).on('jg.complete', function (e){

    });

});

if ($('#vertical').length){
    $('#vertical').lightSlider({
        gallery:true,
        item:1,
        vertical:false,
        thumbItem:5,
        thumbMargin:11,
        slideMargin:0,
        verticalHeight:418,
        vThumbWidth:100,
        controls:false
    });
}

